export function resetPassword (state, data) {
    state.resetPassword = data
}

export function forgotPassword (state, data) {
    state.forgotPassword = data
}